import RatePlansList from "./RatePlansList";
import { usePropertyId } from "../../../../../common/hooks/usePropertyId";
import { withQueryData } from "../../../../../common/withQueryData";
import { usePlansData } from "../../../../../common/hooks/useRatePlansData";
import { useAlertNotification } from "../../../../../common/hooks/useAlertNotification";

const RatePlansPage = () => {
    const { setAlert } = useAlertNotification();
    const propertyId = usePropertyId();

    const { queryResults } = usePlansData(propertyId);

    const onPlanCreated = () => {
        setAlert({
            message: "Rate Plan successfully created!",
            severity: 'success'
        });
    }

    const onPlanDeleted = () => {
        setAlert({
            message: "Rate Plan successfully deleted",
            severity: 'success'
        });
    }

    const onPlanUpdated = () => {
        setAlert({
            message: "Rate Plan successfully updated",
            severity: 'success'
        });
    }

    const onError = (error) => {
        setAlert({
            message: error.message,
            severity: 'error'
        });
    }

    return <>
        <RatePlansListWrapperWithQueryData
            onCreated={onPlanCreated}
            onDeleted={onPlanDeleted}
            onUpdated={onPlanUpdated}
            queryData={queryResults}
            onError={onError}
            propertyId={propertyId}
        />
    </>
}

const RatePlansListWrapper = ({ data: ratePlans, reload, onCreated, onUpdated, onDeleted, onError, propertyId, ...props }) => {
    return <>
        <RatePlansList
            ratePlans={ratePlans}
            propertyId={propertyId}
            onCreated={onCreated}
            onDeleted={onDeleted}
            onUpdated={onUpdated}
            onError={onError}
            {...props}
        />
    </>
}

const RatePlansListWrapperWithQueryData = withQueryData(RatePlansListWrapper)

export default RatePlansPage;